import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Badge, Button, Layout, Menu } from "antd";
import {
  MailOutlined,
  InboxOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  ContainerOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  InteractionOutlined,
  DatabaseOutlined,
  HomeOutlined,
  ReadOutlined,
} from "@ant-design/icons";
import Agents from "./pages/Agents/Agents";
import Archive from "./pages/Archive/Archive";
import FollowUp from "./pages/FollowUp/FollowUp";
import Inbox from "./pages/Inbox/Inbox";
import PastChat from "./pages/PastChat/PastChat";
import Stock from "./pages/Stock/Stock";

import "./MainView.scss";
// eslint-disable-next-line no-unused-vars
import Pusher from "pusher-js";
import { getUserData } from "../../Login/api/userService";
import { useGetStockCount } from "../../../services/hooks/usegetStockCount";
import { ChatLogs } from "./pages/ChatLogs/ChatLogs";
const { Header, Content, Sider } = Layout;

const MainView = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState();
  const userData = getUserData();
  const navigate = useNavigate();
  const getUrl = window.location.pathname;
  const urlData = getUrl.split("/").pop();
  const { data: stock } = useGetStockCount(userData.roles);
  console.log(stock);
  const [activeMenuItem, setActiveMenuItem] = useState(() => {
    switch (urlData) {
      case "stock":
        return "1";
      case "inbox":
        return "2";
      case "follow-up":
        return "3";
      case "past-chat":
        return "4";
      case "archive":
        return "5";
      default:
        return "0";
    }
  });

  useEffect(() => {
    switch (urlData) {
      case "stock":
        setActiveMenuItem("1");
        break;
      case "inbox":
        setActiveMenuItem("2");
        break;
      case "follow-up":
        setActiveMenuItem("3");
        break;
      case "past-chat":
        setActiveMenuItem("4");
        break;
      case "archive":
        setActiveMenuItem("5");
        break;
      case "chat-logs":
        setActiveMenuItem("7");
        break;
      default:
        setActiveMenuItem("0");
    }
    setSearchKeyword("");
  }, [urlData]);

  const navigationItems = [
    {
      id: 0,
      key: 0,
      label: "Agents",
      navigate: "/mainView",
      // link: showDashboardView(),
      icon: <TeamOutlined />,
      // split: true,
      permissions: ["chat-admin", "manager"],
    },
    {
      id: 1,
      key: 1,
      label: <span style={{ color: "#ffffffa6" }}>Stock</span>,
      navigate: "/mainView/stock",
      link: "link",
      icon: (
        <Badge
          count={stock}
          size={"small"}
          offset={[10, -6]}
          style={{
            fontSize: 10,
            height: 11,
            maxHeight: 11,
            lineHeight: "11px",
            padding: "0 3px",
          }}
        >
          <MailOutlined style={{ color: "#ffffffa6" }} />
        </Badge>
      ),
      // split: false,
      permissions: ["chat-admin", "manager"],
    },
    {
      id: 2,
      key: 2,
      label: "Inbox",
      navigate: "/mainView/inbox",
      // navigate: showDashboard,
      // link: showDashboardView(),
      icon: <InboxOutlined />,
      // split: false,
      permissions: ["chat-admin", "manager"],
    },
    {
      id: 3,
      key: 3,
      label: "Follow up",
      navigate: "/mainView/follow-up",
      // navigate: showDashboard,
      // link: showDashboardView(),
      icon: <InteractionOutlined />,
      // split: false,
      permissions: ["chat-admin", "manager"],
    },
    {
      id: 4,
      key: 4,
      label: "Past Chat",
      navigate: "/mainView/past-chat",
      // navigate: showDashboard,
      // link: showDashboardView(),
      icon: <ContainerOutlined />,
      // split: false,
      permissions: ["chat-admin", "manager", "quality-assurance"],
    },
    {
      id: 5,
      key: 5,
      label: "Archive",
      navigate: "/mainView/archive",
      // navigate: showDashboard,
      // link: showDashboardView(),
      icon: <DatabaseOutlined />,
      // split: false,
      permissions: ["chat-admin", "manager", "quality-assurance"],
    },
    {
      id: 7,
      key: 7,
      label: "Chat Logs",
      navigate: "/mainView/chat-logs",
      icon: <ReadOutlined />,
      permissions: [
        "chat-admin",
        "manager",
        "customer-support",
        "phone-support",
        "content",
        "quality-assurance",
      ],
    },
    {
      id: 6,
      key: 6,
      label: "Log Out",
      navigate: "/",
      // link: '/',
      icon: <UserSwitchOutlined />,
      // split: true,
      permissions: [
        "chat-admin",
        "manager",
        "customer-support",
        "phone-support",
        "content",
        "quality-assurance",
      ],
    },
  ];

  const navItemsFilter = (items) => {
    return items.filter((nav) => {
      return nav.permissions.includes(userData.roles[0].name);
    });
  };

  const menuClicked = (data) => {
    navigate(data.item.props.navigate);
  };

  const searchItem = () => {
    const redirect = getUrl + "?search=" + searchKeyword;
    window.open(redirect, "_self");
  };

  const ReturnHome = () => {
    navigate("/mainView/stock");
  };

  const searchWord = (e) => {
    const keyCode = e.hasOwnProperty("which") ? e.which : e.keyCode;
    if (keyCode === 13) {
      searchItem();
    }
    setSearchKeyword(e.target.value);
  };
  return (
    <Layout className="MainView">
      <Sider
        style={{
          overflow: "auto",
          height: "100vh",
          // position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          paddingTop: 60,
        }}
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        <div className="logo" />
        <Menu
          theme="dark"
          mode="inline"
          // defaultSelectedKeys={activeMenuItem && [activeMenuItem]}
          selectedKeys={activeMenuItem && [activeMenuItem]}
          items={navItemsFilter(navigationItems)}
          onClick={menuClicked}
        />
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-background HeaderContainer">
          <div className="HeaderIcons">
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: "trigger",
                onClick: () => setCollapsed(!collapsed),
              }
            )}
            {React.createElement(HomeOutlined, {
              className: "trigger",
              onClick: ReturnHome,
            })}
          </div>
          <div className="SearchContainer">
            <input
              className="SearchInput"
              value={searchKeyword || ""}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyDown={searchWord}
            ></input>
            <Button onClick={searchItem}>Search</Button>
          </div>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            // margin: '24px 16px',
            padding: 10,
            // minHeight: 280,
          }}
        >
          <Routes>
            <Route path="/" element={<Agents />} />
            <Route path="/archive/*" element={<Archive />} />
            <Route path="/follow-up/*" element={<FollowUp />} />
            <Route path="/inbox/*" element={<Inbox />} />
            <Route path="/past-chat/*" element={<PastChat />} />
            <Route path="/stock/*" element={<Stock />} />
            <Route path="/chat-logs/*" element={<ChatLogs />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainView;
